import { render, staticRenderFns } from "./MensagemEdit.vue?vue&type=template&id=327b407f&"
import script from "./MensagemEdit.vue?vue&type=script&lang=js&"
export * from "./MensagemEdit.vue?vue&type=script&lang=js&"
import style0 from "./MensagemEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports